export const GET_CUSTOMER_USED_BIKES_INTEREST_REQUEST =
  "GET_CUSTOMER_USED_BIKES_INTEREST_REQUEST";
export const GET_CUSTOMER_USED_BIKES_INTEREST_SUCCESS =
  "GET_CUSTOMER_USED_BIKES_INTEREST_SUCCESS";
export const GET_CUSTOMER_USED_BIKES_INTEREST_FAILURE =
  "GET_CUSTOMER_USED_BIKES_INTEREST_FAILURE";
